/* Sezioni aggiuntive: cerchi numerici animati e confronto prima/dopo. */
(function () {
  'use strict';
  if (window.__tlExtra) return;
  window.__tlExtra = true;
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    var target = parseFloat(el.dataset.value);
    if (isNaN(target)) return;
    var suffix = el.dataset.suffix || '';
    var start = null, dur = 1400;
    function frame(t) {
      if (!start) start = t;
      var k = Math.min(1, (t - start) / dur);
      var eased = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (k < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function initStats(el) {
    if (reduced || !('IntersectionObserver' in window)) return;
    if (window.Shopify && Shopify.designMode) return;
    el.classList.add('is-armed');
    var nums = el.querySelectorAll('[data-value]');
    nums.forEach(function (n) { if (!isNaN(parseFloat(n.dataset.value))) n.textContent = '0' + (n.dataset.suffix || ''); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        el.classList.add('is-in');
        nums.forEach(countUp);
        io.disconnect();
      });
    }, { threshold: 0.35 });
    io.observe(el);
  }

  function initBA(el) {
    var frame = el.querySelector('.tl-ba__frame');
    var range = el.querySelector('.tl-ba__range');
    if (!frame) return;
    var dragging = false;
    function setPos(p) {
      p = Math.max(0, Math.min(100, p));
      frame.style.setProperty('--pos', p + '%');
      if (range) range.value = Math.round(p);
    }
    function fromEvent(e) {
      var r = frame.getBoundingClientRect();
      return ((e.clientX - r.left) / r.width) * 100;
    }
    frame.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      dragging = true;
      frame.classList.add('is-dragging');
      if (frame.setPointerCapture) { try { frame.setPointerCapture(e.pointerId); } catch (err) {} }
      setPos(fromEvent(e));
      e.preventDefault();
    });
    frame.addEventListener('pointermove', function (e) { if (dragging) setPos(fromEvent(e)); });
    function stop() { dragging = false; frame.classList.remove('is-dragging'); }
    frame.addEventListener('pointerup', stop);
    frame.addEventListener('pointercancel', stop);
    frame.addEventListener('lostpointercapture', stop);
    if (range) range.addEventListener('input', function () { setPos(parseFloat(range.value)); });
    setPos(range ? parseFloat(range.value) || 50 : 50);
  }

  function boot(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-tl-stats]:not([data-tl-ready])').forEach(function (e) { e.dataset.tlReady = '1'; initStats(e); });
    s.querySelectorAll('[data-tl-ba]:not([data-tl-ready])').forEach(function (e) { e.dataset.tlReady = '1'; initBA(e); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
